import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Card,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Divider,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";

import DataTable from "theme/Tables/DataTable";

function AggregatorViewPage() {
  const title = "Aggregator";
  usePageTitle(title);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [aggregator, setAggregator] = useState({});
  const [agents, setAgents] = useState([]);
  const [campaigns, setCampaigns] = useState([]);

  const [currency, setCurrency] = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [licensePrice, setLicensePrice] = useState(null);
  const [minimumQty, setMinimumQty] = useState(null);
  const [vat, setVat] = useState(0.075);

  const [subscriptionPaymentDuration, setSubscriptionPaymentDuration] = useState(null);
  const [licenseQty, setLicenseQty] = useState(null);
  const [openPAGBundleDialog, setOpenPAGBundleDialog] = useState(false);

  const tablePurchasesColumns = [
    { Header: "Purchased On", accessor: "created", align: "left" },
    { Header: "Expires On", accessor: "expires_on", align: "left" },
    { Header: "Licenses", accessor: "quantity", align: "center" },
    { Header: "Used", accessor: "used", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    // { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildPurchasesRows = (data) => {
    const rows = [];
    data.map((purchase) => {
      rows.push({
        created: purchase.created,
        expires_on: purchase.expires_on,
        quantity: purchase.quantity,
        used: purchase.used,
        status: (
          <MDBox>
            <Icon color={purchase.status ? "success" : "error"}>
              {purchase.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={0} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                alert("HEYEYAA");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="error">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const agentTableColumns = [
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildAgentRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        agent: row.name,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignsTableColumns = [
    { Header: "Campaign", accessor: "campaign", align: "left" },
    { Header: "Count", accessor: "count", align: "left" },
    { Header: "Agents", accessor: "agents", align: "left" },
    { Header: "Status", accessor: "status", align: "right" },
    // { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildCampaignsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        campaign: row.campaign,
        count: row.stats.count,
        agents: row.stats.agents,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/aggregators/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result.data.data);
          if (result.data.status === "success") {
            setAggregator(result.data.data.aggregator);
            setCurrency(result.data.data.currency);
            setVat(result.data.data.vat);
            const rows = buildAgentRows(result.data.data.agents);
            setAgents(rows);

            const rowsC = buildCampaignsRows(result.data.data.campaigns);
            setCampaigns(rowsC);

            setLicensePrice(result.data.data.price);
            setMinimumQty(result.data.data.minimum_quantity);
            const rowsP = buildPurchasesRows(result.data.data.purchases);
            setPurchases(rowsP);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function deleteAggregator() {
    setShowLoading(true);
    await axios
      .get(`/portal/aggregators/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          navigate("/aggregators");
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateStatus() {
    setShowLoading(true);
    await axios
      .get(`/portal/aggregators/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function getLicenseFee() {
    if (licenseQty === null || licenseQty <= 0) {
      return 0;
    }

    if (subscriptionPaymentDuration === null || subscriptionPaymentDuration <= 0) {
      return 0;
    }

    return (licensePrice * subscriptionPaymentDuration * licenseQty) / 100;
  }

  function getTotalLicenseFee() {
    const c = getLicenseFee();
    const v = parseFloat(vat) * c;
    return c + v;
  }

  async function buyLicense() {
    if (licenseQty === null) {
      setSeverity("error");
      setErrMsg("License quantity is required.");
      setOpen(true);
      return;
    }

    const qty = parseInt(licenseQty, 10);
    if (qty <= 0) {
      setSeverity("error");
      setErrMsg("Please enter a valid quantity.");
      setOpen(true);
      return;
    }

    if (qty < minimumQty) {
      setSeverity("error");
      setErrMsg(`A minimum of ${minimumQty} licenses per purchase is required.`);
      setOpen(true);
      return;
    }

    if (subscriptionPaymentDuration == null || subscriptionPaymentDuration <= 0) {
      setSeverity("error");
      setErrMsg("Please select a duration");
      setOpen(true);
      return;
    }

    if (window.confirm(`Proceed with payment?`) === false) {
      return;
    }

    setOpenPAGBundleDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      quantity: qty,
      duration: subscriptionPaymentDuration,
    };

    await axios
      .post("portal/aggregators/license/purchase.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openPAGBundleDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox mx={1}>Purchase License</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={0} mb={3}>
            <MDBox p={1}>
              <MDBox mt={1} mb={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox mt={-1}>
                      <MDInput
                        placeholder="1"
                        name="qty"
                        margin="dense"
                        label="Quantity"
                        type="number"
                        fullWidth
                        variant="outlined"
                        value={licenseQty}
                        onChange={(e) => setLicenseQty(e.target.value)}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox mt={0}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Duration</InputLabel>
                        <Select
                          label="Duration"
                          onChange={(e) => {
                            setSubscriptionPaymentDuration(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          <MenuItem value="1">1 Month</MenuItem>
                          <MenuItem value="2">2 Months</MenuItem>
                          <MenuItem value="3">3 Months</MenuItem>
                          <MenuItem value="6">6 Months</MenuItem>
                          <MenuItem value="12">12 Months</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox mt={3} px={3}>
                <Divider />
              </MDBox>
              <MDBox mt={3} px={0}>
                <MDBox display="flex" justifyContent="space-between" mt={1}>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontSize={14}>
                      License Amount:
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontWeight="regular" fontSize={14}>
                      {currency}
                      {getLicenseFee().toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" mt={1}>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontSize={14}>
                      VAT Fee:
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontWeight="regular" fontSize={14}>
                      {currency}
                      {(parseFloat(vat) * getLicenseFee()).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox>
                  <Divider />
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" mt={1}>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontSize={14}>
                      Total Amount:
                    </MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDTypography variant="subtitle2" fontWeight="regular" fontSize={14}>
                      {currency}
                      {getTotalLicenseFee().toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox mt={3} px={0} align="center">
                <MDTypography variant="subtitle2" fontWeight="light" fontSize={12}>
                  {currency}
                  {(licensePrice / 100).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  / License
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPAGBundleDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="contained"
            onClick={() => {
              buyLicense();
            }}
          >
            Purchase
          </MDButton>
        </DialogActions>
      </Dialog>
      {pageLoaded && (
        <MDBox mb={5}>
          <MDBox mt={3} mb={1} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  if (window.history.length > 1) {
                    window.history.back();
                  } else {
                    navigate(`/aggregators`);
                  }
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox>
              <Button
                size="small"
                color="info"
                iconOnly
                onClick={() => {
                  updateStatus();
                }}
                startIcon={
                  <Icon sx={{ cursor: "pointer" }} fontSize="small">
                    {!aggregator.status ? "play_arrow" : "pause"}
                  </Icon>
                }
              >
                {!aggregator.status ? "Enable" : "Disable"}
              </Button>
              &nbsp;
              <Button
                size="small"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Delete this aggregator?`) === true) {
                    deleteAggregator();
                  }
                }}
                startIcon={
                  <Icon sx={{ cursor: "pointer" }} fontSize="small">
                    delete
                  </Icon>
                }
              >
                Delete
              </Button>
            </MDBox>
          </MDBox>
          <MDBox mt={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8} lg={8}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2}>
                    <MDBox mt={1} align="center">
                      <MDTypography mb={1}>
                        <Icon>folder_shared</Icon>
                      </MDTypography>
                      <MDTypography variant="h6">{aggregator.title}</MDTypography>
                    </MDBox>
                    <MDBox mt={4}>
                      <MDBox p={1} display="flex" justifyContent="space-between">
                        <MDBox align="center">
                          <MDTypography variant="h6" fontWeight="light">
                            <Icon>email</Icon>
                            <br />
                            {aggregator.email_address}
                          </MDTypography>
                        </MDBox>
                        <MDBox align="center">
                          <MDTypography variant="h6" fontWeight="light">
                            <Icon>phone</Icon>
                            <br />
                            {aggregator.phone_number}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox align="center" p={2}>
                    <MDBox mt={1} mb={3}>
                      <MDTypography mb={1}>
                        <Icon>support_agent</Icon>
                      </MDTypography>
                      <MDTypography
                        mt={3}
                        variant="h6"
                        fontSize={28}
                      >{`${agents.length.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}`}</MDTypography>
                    </MDBox>
                    <MDBox mt={1}>
                      <MDTypography variant="h6" fontWeight="light">
                        Agents
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium">
                    Licenses
                  </MDTypography>
                  <MDBox>
                    <MDButton
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={() => {
                        setLicenseQty(minimumQty);
                        setSubscriptionPaymentDuration(null);
                        setOpenPAGBundleDialog(true);
                      }}
                      startIcon={<Icon sx={{ fontWeight: "bold" }}>add</Icon>}
                    >
                      Purchase
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox mt={5}>
                  <DataTable
                    table={{ columns: tablePurchasesColumns, rows: purchases }}
                    isSorted
                    entriesPerPage={false}
                    canSearch={false}
                    showTotalEntries
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={3}>
                    <MDBox>
                      <MDTypography variant="h6">Campaign Performance</MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <DataTable
                      table={{ columns: campaignsTableColumns, rows: campaigns }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      canSearch={false}
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
          <MDBox mt={5}>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={3}>
                    <MDBox>
                      <MDTypography variant="h6">Agents</MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <DataTable
                      table={{ columns: agentTableColumns, rows: agents }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      canSearch
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default AggregatorViewPage;
